import { useState, useEffect, useRef } from 'react';

const instagramPosts = [
  {
    id: 1,
    image: "https://public.readdy.ai/ai/img_res/fb6e82ebe3996ae5564bf2fae69bf12f.jpg",
    likes: 342,
    comments: 28,
    caption: "Cada palavra que você escreve para o seu eu do futuro é uma semente de transformação 🌱✨",
  },
  {
    id: 2,
    image: "https://readdy.ai/api/search-image?query=Woman%20journaling%20in%20a%20cozy%20golden%20hour%20setting%20with%20candles%20and%20warm%20ambient%20light%20writing%20in%20a%20beautiful%20notebook%20peaceful%20moment%20of%20self%20reflection%20soft%20cream%20and%20gold%20tones&width=400&height=400&seq=ig2&orientation=squarish",
    likes: 518,
    comments: 45,
    caption: "Momento de conexão consigo mesma. Você já parou hoje para ouvir o que seu coração quer dizer? 💛",
  },
  {
    id: 3,
    image: "https://readdy.ai/api/search-image?query=Inspirational%20quote%20card%20with%20elegant%20gold%20typography%20on%20cream%20background%20with%20subtle%20floral%20watercolor%20elements%20minimalist%20design%20warm%20aesthetic%20motivational%20self%20love%20theme&width=400&height=400&seq=ig3&orientation=squarish",
    likes: 891,
    comments: 67,
    caption: "\"O futuro pertence àqueles que acreditam na beleza dos seus sonhos.\" — Eleanor Roosevelt ✨",
  },
  {
    id: 4,
    image: "https://readdy.ai/api/search-image?query=Beautiful%20sealed%20envelope%20with%20golden%20wax%20seal%20on%20a%20marble%20surface%20surrounded%20by%20eucalyptus%20leaves%20and%20soft%20natural%20light%20elegant%20stationery%20flatlay%20warm%20cream%20and%20gold%20aesthetic&width=400&height=400&seq=ig4&orientation=squarish",
    likes: 276,
    comments: 19,
    caption: "Uma carta selada com amor, esperança e gratidão. Pronta para ser aberta no momento certo 💌",
  },
  {
    id: 5,
    image: "https://readdy.ai/api/search-image?query=Group%20of%20diverse%20women%20smiling%20together%20in%20a%20warm%20cozy%20workshop%20setting%20with%20golden%20ambient%20lighting%20community%20gathering%20empowerment%20circle%20soft%20warm%20tones%20cream%20background&width=400&height=400&seq=ig5&orientation=squarish",
    likes: 634,
    comments: 52,
    caption: "Nossa comunidade cresce a cada dia! Juntas somos mais fortes 🤝💛 #CartaDoEuFuturo",
  },
  {
    id: 6,
    image: "https://readdy.ai/api/search-image?query=Aesthetic%20flatlay%20of%20gratitude%20journal%20with%20golden%20pen%20dried%20lavender%20and%20a%20cup%20of%20tea%20on%20a%20soft%20linen%20cloth%20warm%20morning%20light%20self%20care%20routine%20cream%20and%20gold%20color%20palette&width=400&height=400&seq=ig6&orientation=squarish",
    likes: 423,
    comments: 31,
    caption: "Ritual matinal: gratidão + chá + escrita. Como você começa o seu dia? ☀️📝",
  },
  {
    id: 7,
    image: "https://readdy.ai/api/search-image?query=Hands%20holding%20a%20beautiful%20handmade%20card%20with%20golden%20calligraphy%20close%20up%20shot%20warm%20soft%20lighting%20emotional%20moment%20of%20reading%20a%20personal%20letter%20cream%20and%20gold%20tones%20intimate%20photography&width=400&height=400&seq=ig7&orientation=squarish",
    likes: 756,
    comments: 89,
    caption: "O momento de abrir sua carta é mágico. Cada palavra escrita no passado ganha um novo significado ✨💛",
  },
  {
    id: 8,
    image: "https://readdy.ai/api/search-image?query=Sunset%20golden%20hour%20silhouette%20of%20a%20woman%20with%20arms%20open%20on%20a%20hilltop%20feeling%20free%20and%20empowered%20warm%20orange%20and%20gold%20sky%20inspirational%20freedom%20moment%20cinematic%20photography&width=400&height=400&seq=ig8&orientation=squarish",
    likes: 1024,
    comments: 103,
    caption: "Liberdade é se permitir sonhar grande e dar o primeiro passo. Você merece tudo que deseja 🌅✨",
  },
];

const InstagramGaleria = () => {
  const [hoveredId, setHoveredId] = useState<number | null>(null);
  const [sectionVisible, setSectionVisible] = useState(false);
  const [visiblePosts, setVisiblePosts] = useState<Set<number>>(new Set());
  const sectionRef = useRef<HTMLDivElement>(null);
  const postsRef = useRef<Map<number, HTMLDivElement>>(new Map());

  useEffect(() => {
    const sectionObserver = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) setSectionVisible(true);
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) sectionObserver.observe(sectionRef.current);

    const postObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const idx = Number(entry.target.getAttribute('data-idx'));
            if (!Number.isNaN(idx)) {
              setVisiblePosts((prev) => new Set(prev).add(idx));
            }
          }
        });
      },
      { threshold: 0.2 }
    );

    postsRef.current.forEach((el) => {
      if (el) postObserver.observe(el);
    });

    return () => {
      sectionObserver.disconnect();
      postObserver.disconnect();
    };
  }, []);

  return (
    <section ref={sectionRef} className="py-20 bg-gradient-to-b from-luxury-champagne/20 to-luxury-champagne/40 relative overflow-hidden">
      <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-gold-500/30 to-transparent"></div>

      <div className="container mx-auto px-6">
        {/* Header com animações em cascata */}
        <div className="text-center mb-14">
          {/* Badge Instagram animado */}
          <div
            className={`inline-flex items-center gap-2 bg-gradient-to-r from-pink-500/10 via-rose-400/10 to-orange-400/10 border border-pink-400/20 rounded-full px-5 py-2 mb-5 transition-all duration-700 ${
              sectionVisible ? 'opacity-100 translate-y-0 scale-100' : 'opacity-0 -translate-y-4 scale-90'
            }`}
          >
            <i className="ri-instagram-line text-sm text-pink-500"></i>
            <span className="font-['Montserrat'] text-xs font-medium tracking-wider uppercase text-pink-600">
              @bia.holmes
            </span>
          </div>

          {/* Título animado */}
          <h2
            className={`font-['Playfair_Display'] text-3xl md:text-4xl font-bold text-luxury-charcoal mb-4 transition-all duration-700 delay-150 ${
              sectionVisible ? 'opacity-100 translate-y-0 blur-0' : 'opacity-0 translate-y-6 blur-sm'
            }`}
          >
            Siga Nossa Jornada no <span className="text-transparent bg-clip-text bg-gradient-to-r from-pink-500 via-rose-500 to-orange-400">Instagram</span>
          </h2>

          {/* Subtítulo animado */}
          <p
            className={`font-['Montserrat'] text-sm text-luxury-charcoal/50 max-w-xl mx-auto leading-relaxed transition-all duration-700 delay-300 ${
              sectionVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
            }`}
          >
            Acompanhe dicas de autoconhecimento, histórias inspiradoras e bastidores do Carta do Eu Futuro
          </p>
        </div>

        {/* Grid de Posts com animação wave */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3 md:gap-4 max-w-5xl mx-auto">
          {instagramPosts.map((post, index) => {
            const isVisible = visiblePosts.has(index);
            
            return (
              <a
                key={post.id}
                data-idx={index}
                ref={(el) => {
                  if (el) postsRef.current.set(index, el);
                }}
                href="https://www.instagram.com/bia.holmes"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className={`group relative aspect-square rounded-xl overflow-hidden cursor-pointer transition-all duration-700 ${
                  isVisible ? 'opacity-100 translate-y-0 scale-100' : 'opacity-0 translate-y-8 scale-90'
                }`}
                style={{ transitionDelay: `${index * 80}ms` }}
                onMouseEnter={() => setHoveredId(post.id)}
                onMouseLeave={() => setHoveredId(null)}
              >
                <div className="w-full h-full">
                  <img
                    src={post.image}
                    alt={post.caption}
                    className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
                    loading="lazy"
                  />
                </div>

                <div
                  className={`absolute inset-0 bg-black/60 flex flex-col items-center justify-center gap-3 transition-opacity duration-300 ${
                    hoveredId === post.id ? 'opacity-100' : 'opacity-0'
                  }`}
                >
                  <div className="flex items-center gap-5">
                    <div className="flex items-center gap-1.5">
                      <i className="ri-heart-fill text-white text-base"></i>
                      <span className="font-['Montserrat'] text-white text-sm font-semibold">
                        {post.likes.toLocaleString('pt-BR')}
                      </span>
                    </div>
                    <div className="flex items-center gap-1.5">
                      <i className="ri-chat-3-fill text-white text-base"></i>
                      <span className="font-['Montserrat'] text-white text-sm font-semibold">
                        {post.comments}
                      </span>
                    </div>
                  </div>
                  <p className="font-['Montserrat'] text-white/80 text-[10px] text-center px-3 line-clamp-2 leading-relaxed">
                    {post.caption}
                  </p>
                </div>
              </a>
            );
          })}
        </div>

        {/* Botão seguir com animação */}
        <div className="text-center mt-10">
          <a
            href="https://www.instagram.com/bia.holmes"
            target="_blank"
            rel="noopener noreferrer nofollow"
            className={`inline-flex items-center gap-3 bg-gradient-to-r from-pink-500 via-rose-500 to-orange-400 text-white font-['Montserrat'] text-sm font-semibold px-8 py-3.5 rounded-full hover:shadow-lg hover:shadow-pink-500/25 transition-all duration-700 hover:-translate-y-0.5 cursor-pointer whitespace-nowrap ${
              sectionVisible ? 'opacity-100 translate-y-0 scale-100' : 'opacity-0 translate-y-6 scale-90'
            }`}
            style={{ transitionDelay: '700ms' }}
          >
            <i className="ri-instagram-line text-lg"></i>
            Seguir @bia.holmes
          </a>
        </div>
      </div>
    </section>
  );
};

export default InstagramGaleria;
